export default __webpack_public_path__ + "static/media/hang_up.01457c07.wav";